import { useState } from 'react';
import { Navbar, Footer } from '../components/Balsuite';

const inputStyle = {
  width: '100%', padding: '0.75rem 1rem', borderRadius: '10px',
  border: '1.5px solid rgba(0,0,0,0.12)', outline: 'none',
  fontFamily: 'Inter, sans-serif', fontSize: '0.9rem', color: 'var(--t1)',
  background: '#fff', transition: 'border-color 0.2s', boxSizing: 'border-box',
};

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', company: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => { e.preventDefault(); setSent(true); };

  return (
    <div className="balsuite-page">
      <Navbar />
      <main style={{ maxWidth: '960px', margin: '0 auto', padding: '2rem 2rem 3rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <span className="sec-label">Contact Us</span>
          <h1 className="sec-h2" style={{ marginTop: '0.5rem' }}>
            We'd love to <span className="grad-text">hear from you</span>
          </h1>
          <p className="sec-sub" style={{ maxWidth: '440px', margin: '0.75rem auto 0' }}>
            Whether it's a sales question, a support issue, or just a hello — our team responds
            within one business day.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: '3rem', alignItems: 'start' }}>
          <div>
            {[
              { icon: '📧', label: 'Email', val: 'contact@balvirt.com' },
              { icon: '🌐', label: 'Website', val: 'https://balvirt.com' },
              { icon: '📍', label: 'Location', val: 'Sangamner Maharashtra , 422605' },
              { icon: '⏱️', label: 'Response time', val: 'Within 1 business day' },
            ].map(info => (
              <div key={info.label} style={{ display: 'flex', gap: '1rem', marginBottom: '1.75rem', alignItems: 'flex-start' }}>
                <div style={{
                  width: 44, height: 44, borderRadius: '10px',
                  background: 'rgba(99,102,241,0.08)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.2rem', flexShrink: 0,
                }}>
                  {info.icon}
                </div>
                <div>
                  <div style={{ fontSize: '0.78rem', fontWeight: 600, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.2rem' }}>{info.label}</div>
                  <div style={{ fontSize: '0.9rem', color: 'var(--t1)' }}>{info.val}</div>
                </div>
              </div>
            ))}
          </div>

          {sent ? (
            <div style={{
              textAlign: 'center', padding: '3rem',
              border: '1px solid rgba(99,102,241,0.2)',
              borderRadius: '18px', background: 'rgba(99,102,241,0.04)',
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
              <h3 style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontWeight: 800, fontSize: '1.3rem', marginBottom: '0.5rem' }}>
                Message sent!
              </h3>
              <p style={{ color: 'var(--t2)', fontSize: '0.9rem' }}>
                We'll get back to you within one business day.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--t2)', marginBottom: '0.4rem' }}>Full name *</label>
                  <input name="name" required value={form.name} onChange={handleChange} placeholder="Your name" style={inputStyle} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--t2)', marginBottom: '0.4rem' }}>Work email *</label>
                  <input name="email" type="email" required value={form.email} onChange={handleChange} placeholder="you@company.com" style={inputStyle} />
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--t2)', marginBottom: '0.4rem' }}>Company</label>
                <input name="company" value={form.company} onChange={handleChange} placeholder="Your company name" style={inputStyle} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--t2)', marginBottom: '0.4rem' }}>Subject *</label>
                <input name="subject" required value={form.subject} onChange={handleChange} placeholder="How can we help?" style={inputStyle} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--t2)', marginBottom: '0.4rem' }}>Message *</label>
                <textarea
                  name="message" required value={form.message} onChange={handleChange}
                  rows={5} placeholder="Tell us more..."
                  style={{ ...inputStyle, resize: 'vertical' }}
                />
              </div>
              <button type="submit" className="btn-gradient" style={{ alignSelf: 'flex-start', padding: '0.75rem 2rem' }}>
                Send message →
              </button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
